<template>
<div class="container pb-4">

  <div class="row pb-2">
  <div class="col text-center">
    <h5>Returns</h5>
    </div>
  </div>


    <div class="row">

      <div class="col">

        <div class="card">
        <div class="card-body">

          <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>

          <div v-else-if="items.length == 0" class="text-center">You have no returns</div>

          <div v-else>
        <!-- Desktop -->
        <table class="table d-none d-md-table">
          <thead class="thead-dark">
                <tr>
                  <th class="first-left text-center" width="10%">Image</th>
                  <th class="pl-3" width="40%">Product</th>
                  <th class="pl-3" width="17%">Paid</th>
                  <th class="pl-3" width="18%">Date</th>
                  <th class="first-right pl-3" width="15%">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr class="body" v-for="(item, index) in items" :key="index" @click="openlink(item.id)">
                    <td class="text-center">
                      <img v-if="item.product.images.length > 0" :src="item.product.images[0].url" style="height:4rem;" />
                      <img v-else src="/images/image-not-found.svg" style="height:4rem;" />
                    </td>
                    <td class="pl-3">
                        <div><b>{{item.product.name}}</b></div>
                        <div>Qty {{item.quantity}} &bull; {{item.reason.name}}</div>
                    </td>
                    <td class="pl-3">
                        <div><b>R {{item.product.price*item.quantity}}</b></div>
                    </td>
                    <td class="pl-3">
                      <timeago
                  :datetime="item.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(item.created_at)"></timeago>
                    </td>
                    <td class="pl-3">
                        <span :class="setClass(item.status)">{{item.status}}</span>
                    </td>
                </tr>
              </tbody>
            </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Image • Product • Status</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body" v-for="(item, index) in items" :key="index" @click="openlink(item.id)">
  
          <td class="pl-2 text-center">
              <div class="col">
                <img v-if="item.product.images.length > 0" :src="item.product.images[0].url" style="height:4rem;" />
                <img v-else src="/images/image-not-found.svg" style="height:4rem;" />
                </div>
              <div class="col mt-2">
                <div><b>{{item.product.name}}</b></div>
                <div><b>R {{item.product.price*item.quantity}}</b></div>
                <div>Qty {{item.quantity}}</div>
              </div>
              <div class="col"><timeago
                    :datetime="item.created_at"
                    :auto-update="60"
                    :title="formatDateMoment(item.created_at)"></timeago></div>
              <div class="col mt-2">
                <span :class="setClass(item.status)">{{item.status}}</span>
              </div>
          </td>
            </tr>
          </tbody>
        </table>

</div>
</div>
</div>

      </div>

    </div>
</div>
</template>

<script>
export default {

  data() {
    return {
      items: [],
      loading: false,
    };
  },

  created() {
    this.getProducts();
  },

  methods: {

    openlink(id) {
      if (id) {
        window.open(`/returns/view/${id}`, '_self');
      }
    },

    getProducts() {

      this.loading = true;

      axios
        .get('/returns/list')
        .then((response) => {
          this.items = response.data;
          this.loading = false;
        });

    },

  },
};
</script> 
